const ratingModeLabels = {
  rapid: "Rapid",
  blitz: "Blitz",
  bullet: "Bullet",
  classic: "Clássico",
  classical: "Clássico",
  correspondence: "Correspondência",
};

function highestRating(platform) {
  const valid = Object.entries(platform?.ratings || {})
    .filter(([mode, value]) => typeof value === "number" && Number.isFinite(value) && platform?.rating_details?.[mode]?.games !== 0);
  if (!valid.length) return null;
  const [mode, value] = valid.reduce((highest, current) => current[1] > highest[1] ? current : highest);
  return { value, mode, provisional: platform?.rating_details?.[mode]?.provisional };
}

export default function RatingCards({ ratingCbx, ratingFide, onlineRatings }) {
  const cards = [
    { label: "FSX", best: highestRating(onlineRatings?.fsx), status: onlineRatings?.fsx?.status },
    { label: "Lichess", best: highestRating(onlineRatings?.lichess), status: onlineRatings?.lichess?.status },
    { label: "Chess.com", best: highestRating(onlineRatings?.chess_com), status: onlineRatings?.chess_com?.status },
    { label: "FIDE", value: ratingFide },
    { label: "CBX", value: ratingCbx },
  ];

  return <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3 sm:gap-4 mb-8" data-testid="rating-cards">
    {cards.map(card => (
      <div key={card.label} className="gsx-card-dark p-4" data-testid={`rating-card-${card.label.toLowerCase().replace('.', '')}`}>
        <div className="text-xs text-slate-400 uppercase tracking-widest">{card.label}</div>
        <div className="font-mono text-2xl text-white mt-1">{card.best?.value ?? (card.value || "—")}</div>
        {card.best && <div className="text-xs text-slate-400 mt-1">Maior rating · {ratingModeLabels[card.best.mode] || card.best.mode}{card.best.provisional ? " · Provisório" : ""}</div>}
        {card.status === "stale" && <div className="text-xs text-amber-200 mt-1">Último valor salvo</div>}
        {!card.best && <div className="text-xs text-slate-400 mt-1">{card.status === "pending" ? "Consultando…" : ["unavailable", "rate_limited"].includes(card.status) ? "Atualização indisponível" : card.status === "not_found" ? "Perfil não encontrado" : card.status === "disabled" ? "Conta desativada" : card.status === "not_configured" ? "Perfil não vinculado" : !card.value ? "Sem rating informado" : null}</div>}
      </div>
    ))}
  </div>;
}
